<template>
  <div class="mentions-legales">
    <a @click="$router.go(-1)" class="button return-button">
      <img src="../assets/pictos/back-arrow.svg">
      Retour
    </a>
    <div class="head">
      <h2>Mentions légales</h2>
    </div>
    <div class="content">
      <div class="bloc-cgu">
        <div>
          L’utilisation de ce site implique l’acceptation sans réserve des conditions qui suivent.<br>
          <br>
          Le présent Site Internet <strong>pepz.ede.pia-production.fr</strong> est la propriété de la PIA PRODUCTION SAS, société par actions simplifiée, au capital de 10 000 euros, n° de TVA Intracommunautaire : FR 31533610457, inscrite au registre du commerce et des sociétés de Lyon sous le numéro 533 610 457 et dont le siège social est situé 27 rue Maurice Flandin 69003 Lyon.<br>
          <br>
          Ce Site a pour objet de fournir des informations relatives aux aides financières liées aux travaux de rénovation du bâtiment.<br>
          <br>
          La société PIA PRODUCTION S.A.S. s’efforce d’assurer la fiabilité de l’ensemble des informations diffusées sur ce Site, dont elle se réserve le droit de modifier ou de corriger, à tout moment et sans préavis, le contenu. Ces informations n’ont pas un caractère contractuel.<br>
          <br>
          À ce titre PIA PRODUCTION S.A.S. : <br>
          <ul>
            <li>ne garantit en aucune façon l’exactitude, la précision ou l’exhaustivité des informations mises à disposition sur ce Site, y compris toute liaison informatique utilisée, directement ou indirectement, à partir de ce Site,</li>
            <li>décline toute responsabilité :</li>
            <li style="list-style-type: none">
              <ol>
                <li style="list-style-type: circle">pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le Site,</li>
                <li style="list-style-type: circle">pour tout dommage susceptible de résulter du crédit accordé à ces informations, de leur utilisation ou de l’utilisation d’un produit auquel elles font référence,</li>
                <li style="list-style-type: circle">et plus généralement pour tous dommages, directs ou indirects, quelles qu’en soient les causes, origines, natures et conséquences, provoquées à raison de l’accès de quiconque à ce Site, de son usage ou de l’usage d’autres Sites qui lui sont liés, de même que de l’impossibilité d’accéder à ce Site.</li>
              </ol>
            </li>
          </ul>
          <br>
          Les liens hypertextes mis en place dans le cadre du présent Site en direction d’autres ressources présentes sur le réseau Internet, ne sauraient engager la responsabilité de la société PIA PRODUCTION S.A.S. De même, la simple mention de marque ou de nom de société n’engage pas PIA PRODUCTION S.A.S. sur la qualité réelle ou supposée des produits ou des services rendus.<br>
          <br>
          Les documents contenus dans ce Site et chacun des éléments créés pour ce Site sont soumis aux dispositions régissant le droit de la propriété intellectuelle. Aucune licence, ni aucun autre droit que celui de consulter ce Site, n’est conféré à quiconque au regard de ces mêmes dispositions. La reproduction de tous documents publiés sur ce Site est uniquement autorisée aux fins exclusives d’information pour un usage personnel et privé, toute reproduction et toute utilisation de copies réalisées à d’autres fins étant expressément interdite.<br>
          <br>
          Chaque utilisateur de ce Site qui fournit des informations à PIA PRODUCTION consent à celle-ci l’intégralité des droits transférables relatifs à ces informations et l’autorise à en faire l’usage qui lui plaira et notamment à les utiliser à des fins commerciales. Les informations ainsi fournies par les visiteurs seront considérées comme non confidentielles, et devront être exactes, licites et ne pas nuire aux tiers.<br>
          <br>
          L’utilisateur s’engage à ne pas perturber le bon fonctionnement du Site par des actes ayant pour effet de nuire au Site, à l’éditeur ou aux autres utilisateurs.<br>
          <br>
          La société n’est aucunement responsable quant à la création de liens hypertextes entre son Site et des sites de tiers et quant au contenu desdits sites. De manière générale, les tiers souhaitant créer un lien vers le Site doivent solliciter l’accord préalable du Directeur de Publication du Site. En tout état de cause, la responsabilité de la société ne saurait être engagée au titre de tout préjudice direct ou indirect résultant de liens vers ou à partir du Site et/ou de l’utilisation de sites de tiers à partir de ces liens.<br>
          <br>
          Conformément à l’article 34 de la Loi « Informatique et Libertés » du 06 Janvier 1978, toute personne citée sur une page du Site peut exercer ses droits d’accès, de modification, de rectification ou de suppression des informations le concernant à l’adresse e-mail suivante : contact@pia-production.fr
          <br>
          <br>
        </div>
      </div>
      <div class="bloc-mentions">
        <p><strong>pepz.ede.pia-production.fr</strong> est un site internet édité par PIA PRODUCTION.</p>
        <br>
        <p>
          <strong>PIA PRODUCTION</strong> au capital de 10 000€<br>
          27 rue Maurice Flandin<br>
          69003 LYON<br>
          Tél. 04 82 53 69 50<br>
          E-mail : contact@pia-production.fr<br><br>
          Directeur de publication : Monsieur Florent BUFFIN<br>
        </p>
        <br>

        <p class="legal"><strong>pepz.ede.pia-production.fr</strong> est développé par <a href="http://pia-production.fr" target="_blank">PIA Production SAS</a>.</p>

        <h2>Site herbergé par Abomicro</h2>
        <p>
          Abomicro <br>
          304 A Rue Garibaldi <br>
          69007 Lyon <br>
          <a target="_blank" href="http://www.abomicro.fr">www.abomicro.fr</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MentionsLegales'
}
</script>

<style lang="scss">
.mentions-legales {
  position: relative;
  margin-top: $v-spacer-xl;
  .head {
    background-color: $primary-color;
    border-radius: $radius $radius 0 0;
    color: #fff;
    display: flex;
    align-items: center;
    padding: $v-spacer $h-spacer-lg;
    text-align: left;
    h2 {
      margin: 0;
    }
  }
  .content {
    background-color: #fff;
    border-radius: 0 0 $radius $radius;
    padding: 25px;
    text-align: left;
    font-family: $secondary-font;
    font-size: $text-size;
    h2 {
      margin-top: $v-spacer;
      margin-bottom: $v-spacer-md;
    }
  }
  //Style des accordeons sur les pages RGPD
  .tab {
    position: relative;
    margin-bottom: 1px;
    width: 100%;
    overflow: hidden;
    padding-bottom: 15px;
  }
  .tab h5 {
    padding-left: 20px;
  }
  .tab input {
    position: absolute;
    opacity: 0;
    z-index: -1;
  }
  .tab label {
    position: relative;
    display: block;
    padding: 0 0 0 1em;
    background: $primary-color;
    color: #fff;
    font-weight: bold;
    line-height: 3;
    cursor: pointer;
  }
  .tab-content {
    max-height: 0;
    overflow: hidden;
    background: #f1f1f1;
    -webkit-transition: max-height .35s;
    -o-transition: max-height .35s;
    transition: max-height .35s;
  }
  .tab-content p {
    margin: 1em;
  }
  /* :checked */
  .tab input:checked ~ .tab-content {
    max-height: 2000px;
  }
  /* Icon */
  .tab label::after {
    position: absolute;
    right: 0;
    top: 0;
    display: block;
    width: 3em;
    height: 3em;
    line-height: 3;
    text-align: center;
    -webkit-transition: all .35s;
    -o-transition: all .35s;
    transition: all .35s;
  }
  .tab input[type=checkbox] + label::after {
    content: "+";
  }
  .tab input[type=radio] + label::after {
    content: "\25BC";
  }
  .tab input[type=checkbox]:checked + label::after {
    transform: rotate(315deg);
  }
  .tab input[type=radio]:checked + label::after {
    transform: rotateX(180deg);
  }
}
</style>
